/**
 * @param {object} state
 */
function historyPush (state) {
  if (typeof window === 'undefined') return
  if (JSON.stringify(window.history.state) === JSON.stringify(state)) return

  window.history.pushState(state, null, null)
}

module.exports = { historyPush }
